module.exports = __webpack_public_path__ + "img/xl_anhui.77ae2664.png";